function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5.75C3 2.57436 5.57436 0 8.75 0C11.9256 0 14.5 2.57436 14.5 5.75V8.75C14.5 11.9256 11.9256 14.5 8.75 14.5C5.57436 14.5 3 11.9256 3 8.75V5.75ZM8.75 1.5C6.40279 1.5 4.5 3.40279 4.5 5.75V8.75C4.5 11.0972 6.40279 13 8.75 13C10.8413 13 12.5798 11.4895 12.934 9.5C12.9785 9.25 13 9.16421 13 8.75C13 8.33579 13 8.25 13 8V6.5C13 6.25 13 6.16421 13 5.75C13 5.33579 12.9785 5.25 12.934 5C12.5798 3.01049 10.8413 1.5 8.75 1.5ZM0.75 7C1.16421 7 1.5 7.33579 1.5 7.75V8.75C1.5 12.7541 4.74594 16 8.75 16C12.7541 16 16 12.7541 16 8.75V7.75C16 7.33579 16.3358 7 16.75 7C17.1642 7 17.5 7.33579 17.5 7.75V8.75C17.5 13.3298 13.9814 17.0879 9.5 17.4683V19.75C9.5 20.1642 9.16421 20.5 8.75 20.5C8.33579 20.5 8 20.1642 8 19.75V17.4683C3.5186 17.0879 0 13.3298 0 8.75V7.75C0 7.33579 0.335786 7 0.75 7Z",
  fill: "currentColor"
});

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microphone.298f2a13.svg";
export { ForwardRef as ReactComponent };